var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkyBand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 471",
    fill: "none",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18243c",
    d: "M0 168 C 180 48, 380 8, 560 58 C 780 118, 900 8, 1120 38 C 1280 58, 1380 108, 1440 148 L1440 260 L0 260 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff9f1",
    d: "M0 220 C 180 80, 380 40, 560 90 C 780 150, 900 40, 1120 70 C 1280 90, 1380 140, 1440 180 L1440 471 L0 471 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee8d2",
    opacity: 0.72,
    d: "M80 168 C 220 110, 340 150, 480 128 C 640 102, 760 168, 900 140 C 1040 112, 1180 150, 1360 128 L 1280 200 C 1100 170, 980 210, 820 186 C 640 158, 480 220, 300 186 C 180 164, 80 200, 40 210 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyBand);
export default __webpack_public_path__ + "static/media/sky-band.791a9c3c62b8b13aeadfc79713753eb7.svg";
export { ForwardRef as ReactComponent };